import { Switch } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import { makeStyles } from '@material-ui/core/styles'
import BikeInsuranceDetails from 'src/components/BuyPolicy/insuranceScreens/bike/BikeInsuranceDetails'
import MotorInsuranceMemberDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorInsuranceMemberDetails'
import TermsAndConditionsMotor from 'src/components/BuyPolicy/insuranceScreens/motor/TermsAndConditionMotor'
import ViewPlanDetailsMotor from 'src/components/BuyPolicy/insuranceScreens/motor/ViewPlanDetailsMotor'

const BikeInsuranceDetailsLayout = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.insuranceDetailsContainer}>
        <Switch>
          <RouteMiddleware
            title={'Member Details Form'}
            path='/individual/dashboard/buyPolicy/bike/insuranceDetails/member-details'
            exact
            component={MotorInsuranceMemberDetails}
          />
          <RouteMiddleware
            title={'Terms And Conditions'}
            path='/individual/dashboard/buyPolicy/bike/insuranceDetails/terms-and-conditions'
            component={TermsAndConditionsMotor}
          />
          <RouteMiddleware
            title={'Terms And Conditions'}
            path='/individual/dashboard/buyPolicy/bike/insuranceDetails/plan-details'
            component={ViewPlanDetailsMotor}
          />
          <RouteMiddleware
            title={'Bike Insurance Details'}
            path='/'
            component={BikeInsuranceDetails}
          />
        </Switch>
      </div>
    </>
  )
}

export default BikeInsuranceDetailsLayout

const useStyles = makeStyles({
  insuranceDetailsContainer: {
    width: '100%',
  },
})
